/* Global JavaScript Error-Handler */
import 'misc/log';

$(window)
	.on('error', function (eventObject: any) {
		$(document)
			.off('keydown.disabledKeyboard');

		let event = eventObject.originalEvent;
		let errorDetails = {
			message: event.message,
			filename: event.filename,
			lineno: event.lineno,
			eventPhase: event.eventPhase,
			error_stack: event.stack || 'no stack',
		};
		window.logRemoteError('exception', errorDetails);
	});
